<!-- <div class="beneficio_container" *ngIf="beneficios">
    <div class="label_beneficios_container">
        <p class="cs_label beneficios_label">Quanto mais você compra,</p>
        <p class="cs_label beneficios_label">mais você ganha!</p>
    </div>
    <div class="niveis_container">
        <div *ngFor="let nivel of niveis">
            <div class="nivel" [ngClass]="{'nivel-ativo': nivel.id == idNivel}" [ngStyle]="definirCorDoNivel(nivel.id)">
                <p>{{nivel.nome}}</p>
            </div>
        </div>
    </div>
    <p class="cs_label comochegar_label">Como chegar no nível</p>
    <table>
        <thead>
            <tr class="beneficio_xp">
                <th *ngFor="let n of niveis">{{n.xp}} XP</th>
            </tr>
        </thead>
        <tbody>
            <div class="beneficio_descricao" *ngFor="let b of beneficios">
                <p class="beneficio_label">{{ b.nome }}</p>
                <tr>
                    <td *ngFor="let n of b.beneficiosNiveis">
                        <span class="fa {{ n.ativo ? 'fa-check color_green': 'fa-times color_red'}}"></span>
                    </td>
                </tr>
            </div>
        </tbody>
    </table>
</div> -->

<div class="beneficios">
  <div class="label_beneficios_container">
    <p class="cs_label beneficios_label">Quanto mais você compra,</p>
    <p class="cs_label beneficios_label">mais você ganha!</p>
  </div>

  <div class="beneficios__container" *ngIf="niveis">
    <div class="container__niveis">
      <div
        class="nives__tabs"
        *ngFor="let nivel of niveis; index as i"
        (click)="selecionarNivel(i)"
        [ngClass]="{
          'nivel--selecionado': nivel.id == niveis[nivelSelecionado]?.id
        }"
      >
        <p class="cs_label">{{ nivel.nome }}</p>
      </div>
    </div>

    <div class="container__descricao">
      <div class="nivel">
        <div class="nivel__label">
          <p
            class="cs_label descricao__nivel"
            *ngIf="niveis[nivelSelecionado]?.xp !== 0"
          >
            <span class="fa fa-lock cadeado__nivel"></span>
            {{ niveis[nivelSelecionado]?.xp }} nibis necessários para atingir o
            nível.
          </p>
          <p class="cs_label descricao__texto">
            {{ niveis[nivelSelecionado]?.descricao }}
          </p>
        </div>

        <div *ngIf="niveis[nivelSelecionado]?.beneficiosNiveis">
          <div
            class="nivel__beneficios"
            *ngFor="let b of niveis[nivelSelecionado]?.beneficiosNiveis"
          >
            <p class="cs_label" *ngIf="b.beneficio.ativo">
              <span class="fa fa-check nivel__check"></span>
              {{ b.beneficio.nome }}
            </p>
          </div>
        </div>

        <div *ngIf="exibeSkeleton">
          <ngx-skeleton-loader
            count="3"
            [theme]="{
              'border-radius': '4px',
              height: '16px',
              width: '100%',
              'margin-bottom': '2px'
            }"
          >
          </ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'border-radius': '4px',
              height: '16px',
              width: '40%',
              'margin-bottom': '2px'
            }"
          >
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</div>
